/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Fine_ArtInputs */

const en_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine Art`)
};

const es_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bellas artes`)
};

const fr_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beaux-arts`)
};

const de_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunst`)
};

const ja_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美術品`)
};

const zh_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`艺术品`)
};

const ar_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فنون جميلة`)
};

const id_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seni Rupa`)
};

const it_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arte`)
};

const ru_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Искусство`)
};

const pt_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belas Artes`)
};

const ko_listing_category_fine_art = /** @type {(inputs: Listing_Category_Fine_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예술품`)
};

/**
* | output |
* | --- |
* | "Fine Art" |
*
* @param {Listing_Category_Fine_ArtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_fine_art = /** @type {((inputs?: Listing_Category_Fine_ArtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Fine_ArtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_fine_art(inputs)
	if (locale === "es") return es_listing_category_fine_art(inputs)
	if (locale === "fr") return fr_listing_category_fine_art(inputs)
	if (locale === "de") return de_listing_category_fine_art(inputs)
	if (locale === "ja") return ja_listing_category_fine_art(inputs)
	if (locale === "zh") return zh_listing_category_fine_art(inputs)
	if (locale === "ar") return ar_listing_category_fine_art(inputs)
	if (locale === "id") return id_listing_category_fine_art(inputs)
	if (locale === "it") return it_listing_category_fine_art(inputs)
	if (locale === "ru") return ru_listing_category_fine_art(inputs)
	if (locale === "pt") return pt_listing_category_fine_art(inputs)
	return ko_listing_category_fine_art(inputs)
});